import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { artavaBrand, getArtavaCopy } from '../../branding/artavaBrand';
import styles from './ArtavaCTA.module.css';

export default function ArtavaCTA({
  variant = 'card',
  to = '/support/artava',
  title,
  body,
  primaryLabel,
  secondaryLabel,
}) {
  const { i18n } = useTranslation();
  const copy = getArtavaCopy(i18n.language?.startsWith('it'));
  const compact = variant === 'inline';

  return (
    <section className={`${styles.card} ${compact ? styles.cardInline : ''}`}>
      <div className={styles.copy}>
        <p className={styles.eyebrow}>{artavaBrand.companyName}</p>
        <h3 className={styles.title}>{title || copy.ctaTitle}</h3>
        <p className={styles.body}>{body || copy.ctaBody}</p>
      </div>
      <div className={styles.actions}>
        <Link to={to} className={styles.primaryAction}>
          {primaryLabel || copy.primaryCta}
        </Link>
        <a
          href={artavaBrand.websiteUrl}
          target="_blank"
          rel="noreferrer"
          className={styles.secondaryAction}
        >
          {secondaryLabel || copy.secondaryCta}
        </a>
      </div>
    </section>
  );
}
